<!-- 搜索组件 -->
<template>
    <div
        v-if="componentsData.type == -1"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                      padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                      margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                      borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                  }
                : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.box_bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div class="toper">
            <div
                class="toper-inp"
                :style="
                    componentsData.content.version
                        ? `border: 1px solid ${componentsData.content.border_color}; 
                    text-align: ${componentsData.content.position};
                    height: ${componentsData.content.height}px; 
                    line-height: ${componentsData.content.height}px;
                    background: ${componentsData.content.search_color};
                    border-radius: ${componentsData.content.header.radius}px 0 0 ${componentsData.content.header.radius}px;`
                        : `border: 1px solid ${componentsData.content.border_color};
                    text-align: ${componentsData.content.position};
                    height: ${componentsData.content.height}px;
                    line-height: ${componentsData.content.height}px;
                    background: ${componentsData.content.bg_color};
                    border-radius: ${componentsData.content.marginData.radius}px 0 0 ${componentsData.content.marginData.radius}px;`
                "
            >
                <span
                    class="fs-12"
                    :style="`color:${componentsData.content.text_color};`"
                >
                    {{ componentsData.content.text }}
                </span>
            </div>
            <div
                class="flex-c"
                :style="
                    componentsData.content.version
                        ? `width: ${componentsData.content.height}px; 
                    height: ${componentsData.content.height}px;
                    border: 1px solid ${componentsData.content.bgs_color}; 
                    background: ${componentsData.content.bgs_color};
                    border-radius: 0 ${componentsData.content.header.radius}px ${componentsData.content.header.radius}px 0;`
                        : `width: ${componentsData.content.height}px; 
                    height: ${componentsData.content.height}px;
                    border: 1px solid ${componentsData.content.bgs_color};
                    background: ${componentsData.content.bgs_color};
                    border-radius: 0 ${componentsData.content.marginData.radius}px ${componentsData.content.marginData.radius}px 0;`
                "
            >
                <img
                    v-if="componentsData.content.imgs.picview"
                    class="wh20"
                    :src="componentsData.content.imgs.picview"
                />
            </div>
        </div>
        <!-- style_value: 2 -->
        <div
            v-if="
                componentsData.content.style_value == 2 &&
                componentsData.content.search_img.picview
            "
            class="search-div"
            :style="`margin-top: ${componentsData.content.search_mt}px;`"
        >
            <img
                class="wh50"
                :src="componentsData.content.search_img.picview"
            />
        </div>
        <!-- style_value: 1 -->
        <template v-else>
            <div
                v-if="componentsData.content.btn_text"
                :style="`margin-top: ${componentsData.content.search_mt}px;`"
            >
                <button
                    class="bottomer-btn"
                    :style="
                        componentsData.content.version
                            ? `height: ${componentsData.content.btn_height}px; 
                        line-height: ${componentsData.content.btn_height}px;
                        background: ${componentsData.content.btn_bg_color}; 
                        border: 1px solid ${componentsData.content.btn_border_color};
                        border-radius: ${componentsData.content.footer.radius}px;`
                            : `height: ${componentsData.content.btn_height}px;
                        line-height: ${componentsData.content.btn_height}px;
                        background: ${componentsData.content.btn_bg_color};
                        border: 1px solid ${componentsData.content.btn_border_color};
                        border-radius: ${componentsData.content.marginData.btn_radius}px;`
                    "
                >
                    <span class="color-fff">{{
                        componentsData.content.btn_text
                    }}</span>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.toper {
    width: 100%;
    display: flex;
}
.toper-inp {
    padding-left: 6px;
    flex: 1;
}
.wh20 {
    width: 20px;
    height: 20px;
}
.fs-12 {
    font-size: 12px;
}
.bottomer-btn {
    width: 100%;
    overflow: hidden;
}
.color-fff {
    color: #fff;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.search-div {
    display: flex;
    align-items: center;
    justify-content: center;
}
.wh50 {
    width: 50px;
    height: 50px;
}
</style>